import * as request from '../../request'
import * as serializers from './serializers'
// eslint-disable-next-line import/prefer-default-export
export const getExtractResource = async (storeTabNumber, params) => {
  try {
    const res = await request.get(`v1/wallets/${storeTabNumber}/extract`, {
      params
    })

    return serializers.serializerExtract(res.data, storeTabNumber)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getExtractLevelTwoResource = async (
  storeTabNumber,
  levelOneIdentifier
) => {
  try {
    const res = await request.get(
      `v1/wallets/${storeTabNumber}/indicators/${levelOneIdentifier}`
    )

    return serializers.serializerExtractLevelTwo(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getExtractLeveThree = async (
  storeTabNumber,
  levelOneIdentifier,
  levelTwoIdentifier
) => {
  try {
    const res = await request.get(
      `v1/wallets/${storeTabNumber}/indicators/${levelOneIdentifier}/${levelTwoIdentifier}`
    )

    return serializers.serializerExtractLevelThree(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}
